import { Link } from "react-router-dom";
import { categoryList, eventList, formatHeat, sortByHeat } from "@/utils/content";

const totalNodes = eventList.reduce((sum, item) => sum + item.timeline.length, 0);

export default function HeroSection() {
  const hotList = sortByHeat().slice(0, 5);

  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dark%20atmospheric%20background%20with%20warm%20coral%20red%20and%20amber%20light%20streaks%2C%20layered%20geometric%20shapes%2C%20cinematic%20depth%20of%20field%2C%20moody%20minimal%20composition%2C%20high%20contrast%2C%20no%20text&width=1600&height=900&seq=gossip-hero-bg&orientation=landscape"
        alt="热搜吃瓜事件时间线复盘主题背景"
        title="热搜吃瓜 事件梳理 时间线复盘"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>

      <div className="relative mx-auto grid w-full max-w-content grid-cols-1 items-center gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-[1.25fr_1fr]">
        <div className="rise-in">
          <span className="inline-flex items-center gap-2 rounded-md border border-accent-300/60 bg-accent-500/20 px-3 py-1.5 text-xs font-medium text-accent-100 backdrop-blur">
            <i className="ri-radar-line text-sm"></i>
            按时间顺序，把一件事讲完整
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-white md:text-5xl">
            热搜吃瓜 · 看清热榜事件的来龙去脉
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
            把前因、经过与结果按时间线聚合在一起，完整复盘吃瓜全流程。按事件顺序汇总细节，
            不用反复切换页面，也能快速补齐热门事件的完整经过。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/events"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-list-2-line text-lg"></i>
              进入瓜田总览
            </Link>
            <Link
              to="/#method"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/60 bg-background-50/10 px-6 py-3 text-sm font-medium text-white backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-git-branch-line text-lg"></i>
              看看怎么复盘
            </Link>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4 border-t border-background-200/30 pt-6">
            <div>
              <dt className="text-xs text-background-200">已梳理事件</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-300">
                {eventList.length}
              </dd>
            </div>
            <div>
              <dt className="text-xs text-background-200">时间线节点</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-300">
                {totalNodes}
              </dd>
            </div>
            <div>
              <dt className="text-xs text-background-200">主题分类</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-300">
                {categoryList.length}
              </dd>
            </div>
          </dl>
        </div>

        <div className="w-full rounded-lg border border-background-200/40 bg-background-50/95 p-4 backdrop-blur md:p-5">
          <div className="mb-4 flex items-center justify-between">
            <h4 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-sm"></i>
              </span>
              实时热榜
            </h4>
            <Link
              to="/events"
              className="flex items-center gap-1 text-xs font-medium text-primary-700 transition-colors hover:text-primary-500"
            >
              全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <ul className="flex flex-col divide-y divide-background-200">
            {hotList.map((item, index) => (
              <li key={item.id}>
                <Link
                  to={`/event/${item.slug}`}
                  className="group flex items-center gap-3 py-3"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                      <i className="ri-flashlight-line text-secondary-600"></i>
                      热度 {formatHeat(item.heat)}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}